module.exports = __webpack_public_path__ + "static/media/07_topbandas.aeb80c34.jpg";